import { z } from 'zod';
import { EpisodeStatusSchema } from './procedures';

/**
 * Contrato del dashboard operativo. Todas las agregaciones se calculan en el
 * backend (SQL) — el frontend solo renderiza. Las fechas "hoy"/"mes" se
 * computan en zona horaria de Colombia (America/Bogota).
 */

/** Par genérico etiqueta→conteo para rankings y distribuciones. */
export const DashboardCountItemSchema = z.object({
  label: z.string(),
  count: z.number().int().nonnegative(),
});
export type DashboardCountItem = z.infer<typeof DashboardCountItemSchema>;

/** Consumo agregado de un ítem del catálogo (insumo o medicamento). */
export const DashboardItemUsageSchema = z.object({
  codigo: z.string(),
  nombre: z.string(),
  cantidad: z.number().nonnegative(),
});
export type DashboardItemUsage = z.infer<typeof DashboardItemUsageSchema>;

/** Fila del listado "procedimientos de hoy". */
export const DashboardTodayProcedureSchema = z.object({
  id: z.string(),
  hora: z.string(),
  tipo: z.string(),
  pacienteNombre: z.string(),
  estado: EpisodeStatusSchema,
});
export type DashboardTodayProcedure = z.infer<typeof DashboardTodayProcedureSchema>;

export const DashboardStatsSchema = z.object({
  generadoEn: z.string(),
  // KPIs
  procedimientosHoy: z.number().int().nonnegative(),
  firmasPendientes: z.number().int().nonnegative(),
  pacientesActivos: z.number().int().nonnegative(),
  cerradosHoy: z.number().int().nonnegative(),
  cerradosMes: z.number().int().nonnegative(),
  // Gráficas / rankings
  topTipos: z.array(DashboardCountItemSchema),
  procedimientosDeHoy: z.array(DashboardTodayProcedureSchema),
  rangosEdad: z.array(DashboardCountItemSchema),
  porEntidad: z.array(DashboardCountItemSchema),
  porMedico: z.array(DashboardCountItemSchema),
  porAnestesiologo: z.array(DashboardCountItemSchema),
  topInsumos: z.array(DashboardItemUsageSchema),
  topMedicamentos: z.array(DashboardItemUsageSchema),
});
export type DashboardStats = z.infer<typeof DashboardStatsSchema>;
